export function buildEntityDeepLink(path, { entityType, entityId, mode = 'view', legacyParam } = {}) {
  const params = new URLSearchParams();
  if (entityType) params.set('entityType', entityType);
  if (entityId !== undefined && entityId !== null) params.set('entityId', String(entityId));
  if (mode) params.set('mode', mode);
  if (legacyParam && entityId !== undefined && entityId !== null) params.set(legacyParam, String(entityId));
  return `${path}?${params.toString()}`;
}

export function parseEntityDeepLink(searchParams, legacy = {}) {
  let entityType = searchParams.get('entityType') || '';
  let entityId = searchParams.get('entityId') || '';
  if (!entityId) {
    for (const [param, type] of Object.entries(legacy)) {
      const value = searchParams.get(param);
      if (value) { entityType = type; entityId = value; break; }
    }
  }
  const requestedMode = searchParams.get('mode') || 'view';
  const mode = ['view', 'edit', 'comments', 'delete'].includes(requestedMode) ? requestedMode : 'view';
  return { entityType, entityId, mode };
}

export function clearEntityDeepLink(searchParams, legacyParams = []) {
  const next = new URLSearchParams(searchParams);
  ['entityType', 'entityId', 'mode', ...legacyParams].forEach((key) => next.delete(key));
  return next;
}
